module.exports = __webpack_public_path__ + "img/radio-sri-aman.bdb0ad99.jpg";